<p-dialog
   *ngIf="service.selectedDoctor()"
   header="{{ service.selectedDoctor().firstName }} {{ service.selectedDoctor().lastName }}"
   [(visible)]="service.doctorInfoDialogVisible"
   [modal]="true"
   [style]="{ width: '25rem' }"
   class="doctor-info-dialog"
   [draggable]="false"
   [resizable]="false">
   <ng-container *ngIf="service.selectedDoctor().type !== VSPDoctor_Type.Relief">
      <div class="mt-0 vsp-modal-info">
         <i class="fa fa-envelope"></i>
         &nbsp;&nbsp;
         <a [href]="'mailto:' + service.doctorInfo()?.email">{{ service.doctorInfo()?.email }}</a>
      </div>
      <div class="vsp-modal-info">
         <i class="fa fa-phone"></i>
         &nbsp;&nbsp;{{ service.doctorInfo()?.phone }}
      </div>
      <div class="row">
         <div class="col-3">
            <div class="vc-label mb-1 mt-3 w-100">Status</div>
            <div class="w-100 vsp-modal-info">{{ service.doctorInfo()?.isActive ? "Active" : "Inactive" }}</div>
         </div>
         <div class="col">
            <div class="vc-label mb-1 mt-3 w-100">Home Hospital</div>
            <div class="w-100 vsp-modal-info">{{ service.doctorInfo()?.practiceName }}</div>
         </div>
      </div>
   </ng-container>
   <div
      class="row"
      *ngIf="service.selectedDoctor().type == VSPDoctor_Type.Relief && (service.selectedDoctor()?.agencyName?.length ?? 0 > 0)">
      <div class="col">
         <div class="vc-label mb-0 mt-3 w-100">Agency Name</div>
         <div class="w-100">{{ service.selectedDoctor()?.agencyName }}</div>
      </div>
   </div>
   <div class="row g-3 my-3">
      <div class="col">
         <vc-radio-group
            label="Type"
            [disabled]="true"
            [(ngModel)]="service.selectedDoctor().type"
            [options]="doctorTypes"></vc-radio-group>
      </div>
   </div>
   <ng-template pTemplate="footer">
      <vc-checkbox
         [disabled]="service.week()?.status > 1"
         *ngIf="true || service.selectedDoctor().type !== VSPDoctor_Type.Employee"
         label="Does not work here"
         [inputId]="'doesnotworkhere'"
         [(ngModel)]="service.selectedDoctor().doesNotWorkHere"></vc-checkbox>
      <button
         (click)="cancel()"
         class="v-button v-button-md v-darkgreen-border m-1"
         style="margin-left: auto !important">
         Cancel
      </button>
      <button
         *ngIf="service.week()?.status <= 1"
         (click)="save()"
         class="v-button v-button-md v-darkgreen m-1">
         Save
      </button>
   </ng-template>
</p-dialog>
